import clsx from 'clsx';
import { PageProps } from 'gatsby';
import { twMerge } from 'tailwind-merge';

import { Container } from 'components/GridV2';

import { LocaleNavbarTab } from 'typescriptDefs/layout';

import { Button } from '../Button';
import { LocaleSwitch } from './LocaleSwitch';

type Props = {
  darkBg: boolean;
  location: PageProps['location'];
  pageIsMultilingual: boolean;
  tabs: LocaleNavbarTab[];
  openTab: LocaleNavbarTab | null;
  setOpenTab: (section: LocaleNavbarTab | null) => void;
};

export const DesktopLinks = ({ darkBg, location, pageIsMultilingual, tabs, openTab, setOpenTab }: Props) => {
  return (
    <Container className="hidden flex-row gap-16 py-12 lg:flex">
      {tabs.map((tab) => (
        <Button
          role="menu"
          id="nav-tab"
          variant="text"
          key={tab.title}
          className={twMerge(
            clsx(
              'relative px-12 py-8 font-medium text-grey-500 transition-none first:pl-0 focus:!outline-none active:!outline-none',
              darkBg && 'text-white',
              openTab && 'text-opacity-30',
              openTab && openTab?.title === tab.title && 'text-opacity-100',
            ),
          )}
          onMouseEnter={() => setOpenTab(tab)}
          onClick={() => setOpenTab(tab)}
          onFocus={() => setOpenTab(tab)}
          onKeyDown={(e) => {
            if (e.key === 'ArrowDown') {
              e.preventDefault();
              document.getElementById('nav-menu-item')?.focus();
            }
          }}
        >
          {tab.title}
          {openTab?.title === tab.title && (
            <div
              className={twMerge(
                clsx(
                  'absolute right-0 top-[calc(50%-2.5px)] h-5 w-5 rounded-full bg-primary-150',
                  darkBg && 'bg-secondary-75',
                ),
              )}
            />
          )}
        </Button>
      ))}
      <LocaleSwitch darkBg={darkBg} className="ml-auto" location={location} pageIsMultilingual={pageIsMultilingual} />
    </Container>
  );
};
